import { generateRandomString } from "../components/helpers/treeHelperGeneral";
import { IFolderLocation } from "../interfaces/ISharepointDocument";
import { ISiteInfoLocation } from "../interfaces/ISiteInfo";
import { ITessAccountLocation, ITessProjectFolderLocation, ITessProjectLocation } from "../services/TessService";

export const ComponentTypes = {
  AdvancedSearch: "AdvancedSearch",
  Exchange: "Exchange",
  OneDrive: "OneDrive",
  OneDriveSubFolder: "OneDriveSubFolder",
  Saving: "Saving",
  SavingInBackground: "SavingInBackground",
  SharePoint: "SharePoint",
  SharePointDocuments: "SharePointDocuments",
  SharePointFolders: "SharePointFolders",
  SharePointList: "SharePointList",
  Teams: "Teams",
  TeamDocuments: "TeamDocuments",
  TeamFolders: "TeamFolders",
  GeneralSearch: "GeneralSearch",
  Tess: "Tess",
  TessAccount: "TessAccount",
  TessProject: "TessProject"
};

export interface IDirectoryLocation {
  id: string;
  name: string;
  imgUrl: string;
  type: string;
  sites?: ISiteInfoLocation[];
  folders?: IFolderLocation[];
  foldersNextHref?: string;
  canExpand: boolean;
  expanded: boolean;
  isLoading?: boolean;
  loaded?: boolean;
  treeType?: DirectoryTreeType;
  randomId: string;
  level: number;
  isServerRefreshed: boolean;
  accounts?: ITessAccountLocation[];
  projectFolders?: ITessProjectFolderLocation[];
  projects?: ITessProjectLocation[];
  actions?: JSX.Element[];
  message?: JSX.Element;
}

export enum DirectoryTreeType {
  location,
  site,
  document,
  channel,
  folder,
  tessAccount,
  tessProjectStatusContainer,
  tessProject
}

export const Initiallocations: IDirectoryLocation[] = [
  {
    id: "1",
    name: ComponentTypes.SharePoint,
    imgUrl: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/sharepoint_20x1.svg",
    type: ComponentTypes.SharePoint,
    sites: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "2",
    name: ComponentTypes.Teams,
    imgUrl: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/teams_20x1.svg",
    type: ComponentTypes.Teams,
    sites: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "3",
    name: ComponentTypes.OneDrive,
    imgUrl: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/onedrive_20x1.svg",
    type: ComponentTypes.OneDrive,
    folders: [],
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "4",
    name: ComponentTypes.Tess,
    imgUrl: "https://www.acuity.nl/cms/delivery/media/MCMWFOSYTYFVBL5NEVQBBCPERMXA",
    type: ComponentTypes.Tess,
    canExpand: true,
    expanded: false,
    isLoading: false,
    treeType: DirectoryTreeType.location,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  },
  {
    id: "5",
    name: ComponentTypes.Exchange,
    imgUrl: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/outlook_20x1.svg",
    type: ComponentTypes.Exchange,
    canExpand: false,
    expanded: false,
    randomId: generateRandomString(),
    level: 1,
    isServerRefreshed: false
  }
];
